// modules
import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import DocumentTitle from 'react-document-title';
import axios from 'axios';
import { scroller } from 'react-scroll';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import media from 'styled-media-query';
// assets
import notFound from 'assets/images/404.png';
import stop from 'assets/images/stop.svg';
import nextArrow from 'assets/images/next-arrow.png';
import prevArrow from 'assets/images/prev-arrow.png';
import { externalAccessRoutes } from 'assets/routes';
import { redirect } from 'utils';
// styles
import { Image, Loader } from 'semantic-ui-react';
// components
import IframeBlock from '../../../Dashboard/Course/Lesson/IframeBlock';
import IndefiniteQuestion from '../../../Dashboard/Course/Lesson//IndefiniteQuestion';
import LessonStatsModal from '../../../Dashboard/Course/Lesson//LessonStatsModal';
import Question from '../../../Dashboard/Course/Lesson//Question';
import StarsComponent from '../../../Dashboard/Course/Lesson//StarsComponent';
import TextBlock from '../../../Dashboard/Course/Lesson//TextBlock';
import InteractiveBlock from 'components/InteractiveBlock';
import InteractiveQuestion1 from 'components/InteractiveQuestions/InteractiveQuestion1';
import InteractiveQuestion2 from 'components/InteractiveQuestions/InteractiveQuestion2';
import InteractiveQuestion3 from 'components/InteractiveQuestions/InteractiveQuestion3';
import InteractiveQuestion4 from 'components/InteractiveQuestions/InteractiveQuestion4';
import InteractiveQuestion5 from 'components/InteractiveQuestions/InteractiveQuestion5';
import InteractiveQuestion6 from 'components/InteractiveQuestions/InteractiveQuestion6';
import InteractiveQuestion7 from 'components/InteractiveQuestions/InteractiveQuestion7';
import InteractiveQuestion8 from 'components/InteractiveQuestions/InteractiveQuestion8';
import InteractiveQuestion9 from 'components/InteractiveQuestions/InteractiveQuestion9';
// redux
import { toggleFormulasModal } from 'store/UI';
import { toggleExtraMaterialModal } from 'store/UI';
// utils

const StyledLessonContainer = styled.div`
    min-height: 70vh;
    font-weight: 400;
`;

const StyledErrorContainer = styled.div`
    text-align: center;

    ${media.lessThan('400px')`
        font-size: 14px;

        .image {
            width: 100%;
        }
    `}

    ${media.between('400px', '600px')`
        font-size: 16px;
        
        .image {
            width: 80%;
        }
    `}

    ${media.between('600px', '800px')`
        font-size: 18px;

        .image {
            width: 80%;
        }
    `}

    ${media.greaterThan('800px')`
        font-size: 22px;

        .image {
            width: 60%;
        }
    `}
`;

const StyledLessonNameContainer = styled.div`
    margin-bottom: 2em;
    text-align: center;
    line-height: 1.4;
    font-weight: 600;

    ${media.lessThan('400px')`
        font-size: 18px;

        .section-name {
            margin-right: 0.4em;
        }
    `}

    ${media.between('400px', '600px')`
        font-size: 22px;

        .section-name {
            margin-right: 0.6em;
        }
    `}

    ${media.between('600px', '800px')`
        font-size: 24px;

        .section-name {
            margin-right: 1em;
        }
    `}

    ${media.greaterThan('800px')`
        font-size: 36px;
        
        .section-name {
            margin-right: 1em;
        }
    `}
`;

const StyledBlockContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 500;

    .MathJax_Display,
    .MathJax_Preview {
        width: fit-content;
        display: inline-block!important;
        margin: 0;
    }

    .highlighted {
        background-color: rgb(218, 255, 218) !important;
        border: 3px solid rgb(45, 153, 86);
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.75);
    }

    img {
        max-width: 100%;
        height: auto;
    }

    .ql-video {
        display: block;
        margin: 0 auto;
    }

    ${media.lessThan('400px')`
        margin-bottom: 32px;
        padding: 0px;
        font-size: 16px;

        h3 {
            font-size: 16px;
        }

        .highlighted {
            padding: 16px;
        }

        .ql-video {
            width: 240px;
            height: 135px;
        }
    `}

    ${media.between('400px', '600px')`
        margin-bottom: 40px;
        padding: 0px 16px;
        font-size: 18px;

        h3 {
            font-size: 18px;
        }

        .highlighted {
            padding: 16px;
        }

        .ql-video {
            width: 320px;
            height: 180px;
        }
    `}

    ${media.between('600px', '800px')`
        margin-bottom: 64px;
        padding: 0px 20px;
        font-size: 18px;

        h3 {
            font-size: 18px;
        }

        .highlighted {
            padding: 24px;
        }

        .ql-video {
            width: 400px;
            height: 225px;
        }
    `}

    ${media.between('800px', '1100px')`
        margin-bottom: 72px;
        padding: 0px 24px;
        font-size: 20px;

        h3 {
            font-size: 20px;
        }

        .highlighted {
            padding: 32px;
        }

        .ql-video {
            width: 640px;
            height: 360px;
        }
    `}

    ${media.greaterThan('1100px')`
        margin-bottom: 80px;
        padding: 0px 24px;
        font-size: 22px;

        h3 {
            font-size: 22px;
        }

        .highlighted {
            padding: 40px;
        }

        .ql-video {
            width: 800px;
            height: 450px;
        }
    `}
`;

const StyledExtraMaterialsContainer = styled.div`
    box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.25);

    .header {
        font-weight: 600;
    }

    ${media.lessThan('400px')`
        margin: 0px 0px 16px 0px;
        padding: 16px 8px;
        font-size: 14px;

        .header {
            font-size: 16px;
            margin-bottom: 16px;
        }
    `}

    ${media.between('400px', '600px')`
        margin: 0px 16px 24px 16px;
        padding: 20px 12px;
        font-size: 16px;

        .header {
            font-size: 18px;
            margin-bottom: 24px;
        }
    `}

    ${media.between('600px', '800px')`
        margin: 0px 24px 24px 24px;
        padding: 20px 12px;
        font-size: 16px;

        .header {
            font-size: 18px;
            margin-bottom: 32px;
        }
    `}

    ${media.between('800px', '1100px')`
        margin: 0px 32px 24px 32px;
        padding: 24px 16px;
        font-size: 18px;

        .header {
            font-size: 20px;
            margin-bottom: 32px;
        }
    `}

    ${media.greaterThan('1100px')`
        margin: 0px 120px 48px 120px;
        padding: 32px;
        font-size: 18px;

        .header {
            font-size: 20px;
            margin-bottom: 32px;
        }
    `}
`;

const StyledShortStatsContainer = styled.div`
    color: black;
    text-align: center;
    font-weight: 600;

    ${media.lessThan('400px')`
        margin-bottom: 24px;
        font-size: 16px;
    `}

    ${media.between('400px', '600px')`
        margin-bottom: 32px;
        font-size: 18px;
    `}

    ${media.between('600px', '800px')`
        margin-bottom: 40px;
        font-size: 18px;
    `}

    ${media.between('800px', '1100px')`
        margin-bottom: 40px;
        font-size: 20px;
    `}

    ${media.greaterThan('1100px')`
        margin-bottom: 48px;
        font-size: 22px;
    `}
`;

const StyledSendStatsButtonContainer = styled.div`
    display: flex;
    justify-content: center;

    button {
        cursor: pointer;
        border: none;
        outline: none;
        background-color: #419488;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.5);
        color: white;
        font-weight: 600;
    }

    ${media.lessThan('400px')`
        button {
            padding: 8px;
            font-size: 14px;
            border-radius: 8px;
        }
    `}

    ${media.between('400px', '600px')`
        button {
            padding: 8px 12px;
            font-size: 16px;
            border-radius: 8px;
        }
    `}

    ${media.between('600px', '800px')`
        button {
            padding: 12px 16px;
            font-size: 18px;
            border-radius: 12px;
        }
    `}

    ${media.greaterThan('800px')`
        button {
            padding: 16px 24px;
            font-size: 22px;
            border-radius: 16px;
        }
    `}
`;

const StyledNextLessonLinkContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    
    .container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    .container:hover {
        cursor: pointer;
    }

    .container:hover > .link {
        color: slategrey;
        border-bottom: 1px solid slategrey;
    }

    .link {
        color: black;
        line-height: 1.2;
        text-decoration: none;
        text-transform: lowercase;
    }

    .inactive { 
        cursor: default;
    }

    ${media.lessThan('400px')`
        column-gap: 4px;
        margin-top: 2em;
        
        .container {
            column-gap: 4px;
        }

        .link {
            font-size: 14px;
        }

        .img {
            width: 24px;
            height: 24px;
        }
    `}

    ${media.between('400px', '600px')`
        column-gap: 8px;
        margin-top: 2em;
        
        .container {
            column-gap: 8px;
        }

        .link {
            font-size: 16px;
        }

        .img {
            width: 32px;
            height: 32px;
        }
    `}

    ${media.between('600px', '800px')`
        column-gap: 12px;
        margin-top: 4em;
        
        .container {
            column-gap: 12px;
        }

        .link {
            font-size: 18px;
        }

        .img {
            width: 36px;
            height: 36px;
        }
    `}

    ${media.greaterThan('800px')`
        column-gap: 16px;
        margin-top: 4em;
        
        .container {
            column-gap: 16px; 
        }

        .link {
            font-size: 24px;
        }

        .img {
            width: 48px;
            height: 48px;
        }
    `}
`;

class ExternalAccessCourseLesson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forbidden: false,
            notFound: false,
            answering: false,
            loading: false,
            isLessonStatsModalVisible: false,
            answerCount: 0,
            lesson: {},
        };
    }

    componentDidMount() {
        // get courseId and lessonId from URL
        const courseId = this.props.match.params.courseId;
        const lessonId = this.props.match.params.lessonId;
        // extract access token from query params
        const searchParams = new URLSearchParams(this.props.location.search);
        const accessToken = searchParams.get('accessToken');

        this.fetchLesson(courseId, lessonId, accessToken);
    }

    componentDidUpdate(prevProps) {
        // compare location match parameters
        const { courseId: prevCourseId = '', lessonId: prevLessonId = '' } = prevProps.match.params;
        const { courseId = '', lessonId = '' } = this.props.match.params;

        if (courseId !== prevCourseId || lessonId !== prevLessonId) {
            // scroll to top
            window.scrollTo(0, 0);
            // extract access token from query params
            const searchParams = new URLSearchParams(this.props.location.search);
            const accessToken = searchParams.get('accessToken');
            // fetch new lesson
            this.fetchLesson(courseId, lessonId, accessToken);
        }

        if (this.props.location.hash === '#glossary') {
            this.props.toggleFormulasModal(true);
        }
        if (this.props.location.hash === '#extraMaterial') {
            this.props.toggleExtraMaterialModal(true);
        }
    }

    fetchLesson = async (courseId, lessonId, accessToken) => {
        // reset state indicators
        this.setState({ loading: true, forbidden: false, notFound: false });

        const response = await axios
            .get(externalAccessRoutes.fetchLesson(courseId, lessonId, accessToken))
            .catch((error) => {
                console.error('Error fetching lesson:', error);

                switch (error.response.status) {
                    case 403:
                        this.setState({ loading: false, forbidden: true });
                        break;
                    case 404:
                        this.setState({ loading: false, notFound: true });
                        break;
                    default:
                        alert('Ошибка доступа к уроку');
                        redirect(this, '/');
                        break;
                }

                throw error;
            });

        // parse lesson response
        const lesson = response.data.message;
        // set lesson fields
        lesson.correct = 0;
        // set currentBlock to the last block
        lesson.currentBlock = lesson.blocks.length - 1;

        // set lesson
        this.setState({ loading: false, lesson: lesson }, () => {
            // handle progress
            this.props.handleProgress(this.state.lesson.currentBlock, this.state.lesson.length);

            // transform oembed's
            // actually, this transforms oembed's created when attribute previewsInData was false
            setTimeout(() => {
                document.querySelectorAll('oembed[url]').forEach(element => {
                    if (window['iframely']) {
                        window['iframely'].load(element, element.attributes.url.value);
                    }
                });
            }, 2500);

            // move to selected block
            const selectedBlockId = this.props.location.hash;
            if (selectedBlockId) {
                setTimeout(() => {
                    scroller.scrollTo(selectedBlockId.substring(1), {
                        duration: 1500,
                        smooth: 'easeInOutCubic',
                        offset: -32,
                    });
                }, 1000);
            }
        });
    };

    redirectToLesson = (lessonId) => {
        // get courseId from URL
        const courseId = this.props.match.params.courseId;
        // extract access token from query params
        const searchParams = new URLSearchParams(this.props.location.search);
        const accessToken = searchParams.get('accessToken');
        // redirect to lesson
        window.location = `/external-access/courses/${courseId}/lessons/${lessonId}?accessToken=${accessToken}`;
    };

    toggleLessonStatsModalVisibility = (value) => {
        this.setState({ isLessonStatsModalVisible: value });
    };

    handleChange = (e, data) => {
        this.setState({ [data.name]: data.value });
    };

    handleAnswering = (value) => {
        this.setState({ answering: value });
    };

    handleAnswer = (index, answer, correct, time) => {
        if (this.state.lesson) {
            const blocks = [...this.state.lesson.blocks];

            blocks[index]['answer'] = answer;
            blocks[index]['correct'] = correct
            blocks[index]['time'] = time;

            this.setState((prevState) => ({
                lesson: {
                    ...prevState.lesson,
                    blocks: blocks,
                },
                answerCount: prevState.answerCount + 1,
            }));
        }
    }

    handleCorrect = (isCorrect) => {
        this.setState((prevState) => ({
            lesson: {
                ...this.state.lesson, 
                correct: isCorrect ? prevState.lesson.correct + 1 : prevState.lesson.correct,
            },
        }));
    };

    render() {
        const { lesson } = this.state;
        const { innerWidth, isTimerVisible, t } = this.props;

        if (this.state.loading) {
            return <Loader active size='large' />;
        }

        if (this.state.forbidden) {
            return (
                <StyledErrorContainer>
                    <p>{t('dashboard.course.lesson.forbidden.header')}</p>
                    <Image centered src={stop} alt='' />
                </StyledErrorContainer>
            )
        }

        if (this.state.notFound) {
            return (
                <StyledErrorContainer>
                    <p>{t('dashboard.course.lesson.notfound.text')}</p>
                    <Image centered src={notFound} alt='' />
                </StyledErrorContainer>
            )
        }

        if (!lesson) {
            return null;
        }

        const courseId = this.props.match.params.courseId;
        const lessonId = this.props.match.params.lessonId;
        
        const lessonSectionName = lesson.section ? `${lesson.section}. ` : '';
        const lessonName = lesson.name;
        const lessonBlocks = [];

        const userId = '';
        const userName = 'Гость';
        let questionNumber = 1;

        // add lesson name container
        lessonBlocks.push(
            <StyledLessonNameContainer key='dashboard-lesson-name'>
                <span className='section-name'>{lessonSectionName}</span>
                <span>{ReactHtmlParser(lessonName)}</span>
            </StyledLessonNameContainer>
        );

        // iterate over lesson blocks and add block components
        if (lesson.blocks && lesson.blocks.length !== 0) {
            for (let i = 0; i <= lesson.currentBlock; i++) {
                const block = lesson.blocks[i];

                // replace $$placeholder$$ with user name
                if (block.text) {
                    block.text.replace('$$placeholder$$', userName);
                }

                // select block component based on block type
                let item;
                switch (block.blockType) {
                    case 'indefiniteQuestion':
                        item = (
                            <IndefiniteQuestion
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={lessonId}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question':
                        item = (
                            <Question
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'text':
                        item = (
                            <TextBlock
                                demo
                                block={block}
                                courseId={courseId}
                                lessonId={lessonId}
                                text={block.text}
                                userId={userId}
                            />
                        );
                        break;
                    case 'iframe':
                        item = <IframeBlock src={block.iframeSrc} />;
                        break;
                    case 'interactive':
                        item = (
                            <InteractiveBlock
                                demo
                                highlighted={block.highlighted}
                                person={block.person}
                                popupTextList={block.popupTextList}
                                text={block.text}
                            />
                        );
                        break;
                    case 'question-interactive-fill-slots':
                        item = (
                            <InteractiveQuestion1
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-fill-from-list':
                        item = (
                            <InteractiveQuestion2
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-classification':
                        item = (
                            <InteractiveQuestion3
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-find-pairs':
                        item = (
                            <InteractiveQuestion4
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-find-matches':
                        item = (
                            <InteractiveQuestion5
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-select-words':
                        item = (
                            <InteractiveQuestion6
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-guess-word':
                        item = (
                            <InteractiveQuestion7
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-word-search':
                        item = (
                            <InteractiveQuestion8
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    case 'question-interactive-order-words':
                        item = (
                            <InteractiveQuestion9
                                demo
                                block={block}
                                handleAnswering={this.handleAnswering}
                                handleAnswer={this.handleAnswer}
                                handleCorrect={this.handleCorrect}
                                courseId={courseId}
                                lessonId={lessonId}
                                id={this.state.id}
                                index={i}
                                innerWidth={innerWidth}
                                section={lesson.section}
                                showTimer={isTimerVisible}
                                nickname={userName}
                                questionNumber={questionNumber}
                                text={block.text}
                            />
                        );
                        questionNumber++;
                        break;
                    default:
                        item = null;
                }
                // push item
                lessonBlocks.push(
                    <StyledBlockContainer
                        key={`dashboard-lesson-block-${block._id}`}
                        id={block._id}
                        name={i === lesson.currentBlock ? 'last-block' : ''}
                    >
                        {item}
                    </StyledBlockContainer>
                );
            }
        }

        
        // add lesson extra material
        if (lesson.extraMaterial) {
            lessonBlocks.push(
                <StyledExtraMaterialsContainer key='dashboard-lesson-extra-materials'>
                    <div className='header'>{t('dashboard.course.lesson.extraMaterials')}:</div>
                    <div className='ck-content' style={{ width: '100%',}}>
                        {ReactHtmlParser(lesson.extraMaterial)}
                    </div>
                </StyledExtraMaterialsContainer>
            );
        }

        if (lesson.questions > 0) {
            // add stars
            lessonBlocks.push(
                <StarsComponent
                    key='dashboard-lesson-stars'
                    name='dashboard-lesson-stars'
                    questions={lesson.questions}
                    correct={lesson.correct}
                />
            );
            // add caption under stars
            lessonBlocks.push(
                <StyledShortStatsContainer key='dashboard-lesson-short-stats'>
                    <p>
                        {t('dashboard.course.lesson.totalQuestions')}: {lesson.questions}
                    </p>
                    <p>
                        {t('dashboard.course.lesson.correctQuestions')}: {lesson.correct} ({Math.round((lesson.correct / lesson.questions) * 100)}%)
                    </p>
                </StyledShortStatsContainer>
            );
            // add button to show question stats
            lessonBlocks.push(
                <StyledSendStatsButtonContainer key='dashboard-lesson-send-stats'>
                    <button onClick={() => this.toggleLessonStatsModalVisibility(true)}>
                        {t('dashboard.course.lesson.sendStats')}
                    </button>
                </StyledSendStatsButtonContainer>
            );
            // add modal with question stats 
            lessonBlocks.push(
                <LessonStatsModal
                    open={this.state.isLessonStatsModalVisible}
                    onClose={() => this.toggleLessonStatsModalVisibility(false)}
                    key='dashboard-lesson-footer-stats'
                    extraMaterial={lesson.extraMaterial}
                    correct={lesson.correct}
                    courseId={courseId}
                    lessonId={lessonId}
                    lessonName={lesson.name}
                    innerWidth={innerWidth}
                    section={lesson.section}
                    questions={lesson.questions}
                    blocks={lesson.blocks}
                    answerCount={this.state.answerCount}
                />
            );
        }

        lessonBlocks.push(
            <StyledNextLessonLinkContainer key='dashboard-lesson-links'>
                {lesson.prevLesson && lesson.prevLesson._id && (
                    <div className='container' onClick={() => this.redirectToLesson(lesson.prevLesson._id)}>
                        <img className='img' src={prevArrow} alt='' />
                        <span className='link'>{t('dashboard.course.lesson.prevLesson')}</span>
                    </div>
                )}
                {lesson.nextLesson && lesson.nextLesson._id && (
                    <div className='container' onClick={() => this.redirectToLesson(lesson.nextLesson._id)}>
                        <span className='link'>{t('dashboard.course.lesson.nextLesson')}</span>
                        <img className='img' src={nextArrow} alt='' />
                    </div>
                )}
            </StyledNextLessonLinkContainer>
        );

        return (
            <DocumentTitle title={`${lessonSectionName} ${lessonName}`}>
                <StyledLessonContainer>
                    {lessonBlocks}
                </StyledLessonContainer>
            </DocumentTitle>
        );
    }
}

const mapStateToProps = (state) => ({
    isTimerVisible: state.ui.isTimerVisible,
});

const mapDispatchToProps = (dispatch) => ({
    toggleFormulasModal: value => dispatch(toggleFormulasModal(value)),
    toggleExtraMaterialModal: value => dispatch(toggleExtraMaterialModal(value))
});

export default withRouter(
    compose(
        connect(mapStateToProps, mapDispatchToProps),
        withTranslation(),
    )(ExternalAccessCourseLesson)
);
